'use client';

interface ProductTypeBadgeProps {
  badge: string;
}

// Tailwind JIT 호환을 위해 full class name 매핑 (동적 조합 불가)
const BADGE_BG_CLASS: Record<string, string> = {
  NEW: 'bg-store-badge-new-bg',
  디지털: 'bg-store-badge-digital-bg',
  '디지털+실물': 'bg-store-badge-digital-physical-bg',
  '디지털+기프티콘': 'bg-store-badge-digital-gifticon-bg',
  실물: 'bg-store-badge-physical-bg',
};

const FALLBACK_BG_CLASS = 'bg-store-badge-digital-bg';

export default function ProductTypeBadge({ badge }: ProductTypeBadgeProps) {
  const bgClass = BADGE_BG_CLASS[badge] ?? FALLBACK_BG_CLASS;

  return (
    <div className={`flex items-center justify-center gap-0 rounded-[2px] px-1 py-0.5 ${bgClass}`}>
      <p className="text-xs font-medium leading-[14px] text-store-badge-text">{badge}</p>
    </div>
  );
}
